"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExploreTokensPaginatedListSchema = exports.ExploreTokensSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
const VolumeStats_1 = require("./VolumeStats");
exports.ExploreTokensSchema = zod_1.z.object({
    tokenID: zod_1.z.string(),
    price: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    priceChange1h: zod_1.z.number(),
    priceChange24h: zod_1.z.number(),
    fdv: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    volume: VolumeStats_1.VolumeStatsSchema,
});
exports.ExploreTokensPaginatedListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.ExploreTokensSchema),
    metadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
